import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import type { ProductOptionKeyTypeModel } from '@models/types'

import type { AppDispatch } from '@redux/store'
import type { Action, Errors } from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/productOptionKeyType/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/productOptionKeyType/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/productOptionKeyType/FETCH_FAILURE'

export type ProductOptionKeyTypeModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
}

// Initial State
const initialState: ProductOptionKeyTypeModuleState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess() {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadProductOptionKeyTypes() {
  return (dispatch: AppDispatch) => {
    dispatch(fetchRequest())

    const promise = api('/references/product-option-key-types')
      .then(({ data }: { data: ProductOptionKeyTypeModel[] }) => {
        const normalizedJson = normalize(data, Schemas.PRODUCT_OPTION_KEY_TYPE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: ProductOptionKeyTypeModuleState = initialState,
  action: Action = { type: '' },
): ProductOptionKeyTypeModuleState {
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
